import { useLocation } from 'react-router-dom'

export const pages = [
  '',
  'customer',
  'company',
  'activity',
  'turnover',
  'contacts',
  'estimate',
  'interested'
  // 'activation',
  // 'frequency',
  // 'resume',
  // 'payment-choice',
  // 'payment',
  // 'signature-choice',
  // 'signature'
]

export const GetPageIndex = () => {
  const { pathname } = useLocation()
  const currentPage = pathname.split("/")[3]?.split("?")[0]
  const index = pages.findIndex(page => page === currentPage)

  return currentPage && index !== -1
    ? index
    : 0
}

export const nextPage = ({pathname, navigate, state, data}) => {
  const currentPage = pathname.split("/")[3]?.split("?")[0]
  const index = pages.findIndex(page => page === currentPage)
  const page = pages[index+1]
  const savedState = {
    ...state,
    ...(data || {})
  }

  // Save state
  localStorage.setItem('RCPro', JSON.stringify({
    page, savedState
  }))

  // Next page
  setTimeout( () => {
    navigate('../'+page, {
      state: savedState
    })
  }, 250)
}